import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const MAX_BUTTON_WIDTH = Device.isTabletOrWeb ? 150 : 150;
export const ITEM_MARGIN = 6;
const BUTTON_HEIGHT = (MAX_BUTTON_WIDTH - ITEM_MARGIN) * 1.15;
const BUTTON_WIDTH = MAX_BUTTON_WIDTH - ITEM_MARGIN;

const baseStyles = {
    modalContainer: {
        width: '100%',
        height: '100%'
    },
    container: {
        marginTop: Device.isTabletOrWeb ? '10%' : 40,
        backgroundColor: Theme.primaryBackgroundColor,
        height: Device.isTabletOrWeb ? '70%' : '100%',
        marginHorizontal: Device.isTabletOrWeb ? '30%' : Theme.primaryMargin + 6,
        alignItems: 'center'
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.title,
        marginHorizontal: 18,
        marginBottom: 10,
        color: Theme.primaryTextColor,
        textAlign: 'center',
        marginVertical: 12
    },
    subTitle: {
        fontSize: Theme.fontSizes.subtitle
    },
    gridView: {
        width: '100%',
        marginBottom: 100
    },
    button: {
        alignSelf: 'center',
        justifyContent: 'center',
        width: BUTTON_WIDTH,
        height: BUTTON_HEIGHT,
        maxWidth: BUTTON_WIDTH,
        maxHeight: BUTTON_HEIGHT
    },
    buttonHeadline: {
        color: Theme.secondaryTextColor,
        fontSize: 15
    },
    closeIcon: Device.isWeb
        ? {
              marginTop: 200,
              marginRight: '20%',
              zIndex: 100
          }
        : { zIndex: 100 }
};

export default StyleSheet.create(baseStyles);
